const PlayerParametresIntegrated = ({language , token}) => {
    const newPlayerParametresIframe = "https:" +
    window.process.env.URL_PlayerParametres
    +  "?lang=" + language + "&token=" +
      token
  
    return (
      <iframe
        id="iframe_playerParametres_display"
        src={newPlayerParametresIframe}
        allowFullScreen
        frameBorder={"0"}
        style={{ width: '100%', height: '100%', overflow: 'hidden' }}
      />
    );
  };
  
  export default PlayerParametresIntegrated